<div class="storage-override-dialog">
  <h2 mat-dialog-title>{{ 'override' | translate }} - {{ data.prdNameEn }}</h2>

  <mat-dialog-content>
    <div class="info-section">
      <div class="info-row">
        <span class="label">{{ 'storage' | translate }}:</span>
        <span class="value">{{ data.storagePath }}</span>
      </div>
      <div class="info-row">
        <span class="label">{{ 'currentOnHand' | translate }}:</span>
        <span class="value" [class.negative]="data.currentOnHand < 0">{{ data.currentOnHand }}</span>
      </div>
    </div>

    <div class="serial-loading" *ngIf="isSerialized === null && !productError" aria-busy="true">
      <mat-spinner diameter="24"></mat-spinner>
    </div>
    <div class="serial-load-error" role="alert" *ngIf="productError">
      <strong>{{ 'serialForm.productError' | translate }}</strong>
      <button mat-stroked-button type="button" (click)="loadProduct()">{{ 'serials.tryAgain' | translate }}</button>
    </div>
    <div class="serial-info" role="status" *ngIf="isSerialized && unrecorded > 0">
      <mat-icon>info</mat-icon>
      <span>{{ (unrecorded === 1 ? 'serialForm.unrecordedOne' : 'serialForm.unrecorded') | translate: { count: unrecorded } }}</span>
    </div>

    <form [formGroup]="form" class="override-form">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ 'newOnHand' | translate }}</mat-label>
        <input matInput type="number" formControlName="newOnHand" required [attr.min]="isSerialized ? 0 : null"
               #mainInput (keydown.enter)="onEnter($event)">
        <mat-hint *ngIf="isSerialized && delta === 0">{{ 'serialForm.hintSame' | translate }}</mat-hint>
        <mat-hint *ngIf="isSerialized && delta < 0">{{ 'serialForm.hintDown' | translate: { count: -delta } }}</mat-hint>
        <mat-hint *ngIf="isSerialized && delta > 0">{{ 'serialForm.hintUp' | translate: { count: delta } }}</mat-hint>
      </mat-form-field>

      <app-serial-form *ngIf="isSerialized && delta !== 0 && !invalidQuantity" [variant]="delta > 0 ? 'adjustUp' : 'adjustDown'" [needed]="absDelta"
                       [patterns]="patterns" [stock]="stock" [stockState]="stockState" [refused]="refused" [failed]="failed" [stale]="stale" [staleOnHand]="staleOnHand" [disabled]="isSubmitting"
                       (serialsChange)="serials = $event" (blockedChange)="blocked = $event"
                       (reload)="loadStock()" (retry)="onSubmit()"></app-serial-form>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ 'reason' | translate }} ({{ 'optional' | translate }})</mat-label>
        <textarea matInput formControlName="reason" rows="3"></textarea>
      </mat-form-field>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <span class="serial-foot-note" *ngIf="isSerialized && delta === 0">{{ 'serialForm.footNothing' | translate }}</span>
    <span class="serial-foot-note" *ngIf="isSerialized && delta !== 0 && serials.length < absDelta">{{ (delta > 0 ? 'serialForm.footMoreEnter' : 'serialForm.footMoreTick') | translate: { count: absDelta - serials.length } }}</span>
    <span class="serial-foot-note" *ngIf="isSerialized && delta !== 0 && serials.length === absDelta">{{ 'serialForm.footChange' | translate: { from: data.currentOnHand, to: form.value.newOnHand } }}</span>
    <button mat-button (click)="onCancel()">{{ 'cancel' | translate }}</button>
    <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="!canSubmit">
      <mat-spinner *ngIf="isSubmitting" diameter="20"></mat-spinner>
      <span *ngIf="!isSubmitting">{{ 'confirm' | translate }}</span>
    </button>
  </mat-dialog-actions>
</div>
